import React from 'react';
import { cn } from 'src/lib/utils';
import { buttonVariants } from 'src/components/ui/button';
import { ChevronLeft, ChevronRight, MoreHorizontal } from 'lucide-react';

const Pagination = function Pagination({ className, ...props }) {
  return (
    <nav role='navigation' aria-label='pagination' className={cn('mx-auto flex w-full justify-end', className)} {...props} />
  );
};
Pagination.displayName = 'Pagination';

const PaginationContent = React.forwardRef(function PaginationContent(props, ref) {
  const { className, ...rest } = props;
  return <ul ref={ref} className={cn('flex flex-row items-center gap-1', className)} {...rest} />;
});
PaginationContent.displayName = 'PaginationContent';

const PaginationItem = React.forwardRef(function PaginationItem(props, ref) {
  const { className, ...rest } = props;
  return <li ref={ref} className={cn('', className)} {...rest} />;
});
PaginationItem.displayName = 'PaginationItem';

const PaginationLink = function PaginationLink({ className, isActive, size = 'icon', ...props }) {
  return (
    <a
      aria-current={isActive ? 'page' : undefined}
      className={cn(
        buttonVariants({
          variant: isActive ? 'outline' : 'ghost',
          size,
        }),
        'cursor-pointer',
        className,
      )}
      {...props}
    />
  );
};
PaginationLink.displayName = 'PaginationLink';

const PaginationPrevious = function PaginationPrevious({ className, ...props }) {
  return (
    <PaginationLink aria-label='Go to previous page' size='default' className={cn('gap-1 pl-2.5', className)} {...props}>
      <ChevronLeft size={16} strokeWidth={1.5} />
      <span>Previous</span>
    </PaginationLink>
  );
};
PaginationPrevious.displayName = 'PaginationPrevious';

const PaginationNext = ({ className, ...props }) => {
  return (
    <PaginationLink
      aria-label='Go to next page'
      size='default'
      className={cn('flex items-center gap-1 pr-2.5', className)}
      {...props}>
      <span>Next</span>
      <ChevronRight size={16} strokeWidth={1.5} />
    </PaginationLink>
  );
};
PaginationNext.displayName = 'PaginationNext';

const PaginationEllipsis = function PaginationEllipsis({ className, ...props }) {
  return (
    <span aria-hidden className={cn('flex h-9 w-9 items-center justify-center', className)} {...props}>
      <MoreHorizontal size={16} strokeWidth={1.5} />
      <span className='sr-only'>More pages</span>
    </span>
  );
};
PaginationEllipsis.displayName = 'PaginationEllipsis';

export {
  Pagination,
  PaginationContent,
  PaginationLink,
  PaginationItem,
  PaginationPrevious,
  PaginationNext,
  PaginationEllipsis,
};
